function setAccordionEventListeners( ) 
{
    window.addEventListener('resize', function ( ) {
        var currentWidth = window.innerWidth;
        var blogs        = document.querySelectorAll( '.toc-blogs-container' );
        var arrows       = document.querySelectorAll( '.toc-arrow' );

        if ( currentWidth > 1200 )
        {
            
            blogs.forEach( blog =>
            {
                blog.style.maxHeight = null;
            });
        }
        else
        {

            blogs.forEach( ( blog, index ) =>
            {
                if ( blog.style.maxHeight )
                {
                    blog.style.maxHeight = blog.scrollHeight + "px";
                    arrows[ index ].classList.add( "active" );
                }
                else
                {
                    blog.style.maxHeight = null;
                    arrows[ index ].classList.remove( "active" );
                }
            });
        }
    });
}

function startAccordian( )
{
    var header = document.getElementsByClassName( 'toc-header' );
    if ( header )
    {
        for ( var i = 0; i < header.length; i++ )
        {
            header[ i ].addEventListener( "click", function( ) 
            {
                var blogs = this.nextElementSibling;
                var arrow = this.querySelector( '.toc-arrow' );
                if ( blogs.style.maxHeight )
                {
                    blogs.style.maxHeight = null;
                    arrow.classList.toggle( 'active' );
                }
                else
                {
                    blogs.style.maxHeight = blogs.scrollHeight + "px";
                    arrow.classList.toggle( 'active' );
                }   
            });
        }
    }

    setAccordionEventListeners( );
}

window.addEventListener( "DOMContentLoaded", startAccordian );